import { TranslatorPlugin } from './TranslatorPlugin';
export * from './Translator';
export * from './TranslatorFactory';
export * from './TranslatorContext';
export * from './TranslatorPlugin';
export * from './types';
export default TranslatorPlugin;
//# sourceMappingURL=index.js.map